module.exports = __webpack_public_path__ + "img/Rugby.e1e9377b.jpg";